import { IssueCommentService as OvermapIssueCommentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueCommentService extends OvermapIssueCommentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
